CANDYRACK_DOCUMENT_LISTENER = true;

// OPEN DRAWER CART WHEN UPGRADE ADDED START
window.CANDYRACK_CUSTOM_UPGRADE_HANDLE = () => {
  window.updateCart()
}
// OPEN DRAWER CART WHEN UPGRADE ADDED END